module.exports = __webpack_public_path__ + "img/usb-flash-drive.b2d46d33.svg";